exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selector-container[data-v-740bfcfb] {\n\tmargin-bottom: 24px;\n}\n", ""]);

// exports
